import React from 'react'
import { useQuery } from '@apollo/client';
import gql from "graphql-tag"
import {Row, Col, Container } from 'react-bootstrap';

import VideoPost from "../News/NewsPost/VideoPost"


function SearchVideo(props) {
	
	const data = props.data

	var videos = [];

	 videos = props.data.filter((item) => item.Title.toLowerCase().includes(props.text.toLowerCase()))
	// for(var i=0; i < props.data.length; i++){
	// 	let title = props.data[i].Title.toLowerCase()
	// 	if(title.includes(props.text)) {
	// 		videos.push(props.data[i])
	// 	}
	// }
	return (
	<div className="components-News--filter-news">
	{videos.length == 0 ? 
  		<div className="news-posts" >
    		<Container>
        		<Row> 
        			<Col lg={12}>
                		<div className="no-match-news">
                			No match found
                		</div>
        			</Col>
        		</Row>
        	</Container>
        </div> : <VideoPost data={videos} url_tag={props.tag == 'videos' ? '' : 'career'} menus={props.menus} pageContext={props?.pageContext}/> }
	</div>
	)
}

export default SearchVideo
